export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '52 Weekly Ninja Coaching Themes',
    value: '15',
    desc: 'A complete collection of 52 ready-to-use weekly themes to help you keep your classes fresh, meaningful, and challenging all year. Each theme includes a central focus, skill progression, session message, and specific challenge.',
    benefit: 'No prep needed. Open, read, and train.',
  },
  {
    id: '02',
    title: 'Definitive Coaching Cues Library',
    value: '15',
    desc: 'A practical library of coaching cues ready for every moment of class — entries, technique, corrections, progressions, transitions, challenges, and endings.',
    benefit: 'The words are already there. Just say them.',
  },
  {
    id: '03',
    title: 'Adaptation & Regression Guide',
    value: '12',
    desc: 'A clear reference guide with accessible adaptations, regression options, and safer alternatives for athletes at all levels, different ages, limited equipment, and spaces.',
    benefit: 'Have the right option ready before class starts.',
  },
  {
    id: '04',
    title: '50 Emergency Ninja Classes Ready to Teach',
    value: '15',
    desc: "A collection of 50 complete backup classes for days when there's no time to plan. Includes short options, fundamental movement, technique, course flow, mixed-level, and challenges — all completely structured and ready to teach.",
    benefit: 'You’ll never walk into class unprepared again. Open, choose, train.',
  },
  {
    id: '05',
    title: 'Ninja Class Search System',
    value: '12',
    desc: 'A quick reference system that helps you choose the right class in less than 60 seconds — by duration, level, athlete type, skill focus, available equipment, and group energy.',
    benefit: 'The system chooses. You train.',
  },
]

export const bonusesTotalValue = '$69.00'
